<script>
  import _base from '../../../../_default/components/_base.vue'
  import CHeader from './components/Header.vue'

  export default{
    name: 'Perito',
    extends: _base,
    data () {
      return {}
    },
    computed: {},
    mounted () {
//      this._menuFolded(true)
    },
    destroyed () {},
    methods: {},
    components: {CHeader}
  }
</script>

<template>
    <div class="app-content">
        <div class="app-content-body banners">
            <CHeader/>
            <router-view></router-view>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Main.vue?5ecd68aa